import * as types from './types';

const getRatings = branchId => ({
  type: types.FETCH_RATINGS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/publisher/getReputation`,
    method: 'GET',
    query: { branchId }
  }
});

const getQuality = branchId => ({
  type: types.FETCH_QUALITY,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/publisher/getQuality`,
    method: 'GET',
    query: { branchId }
  }
});

const getReports = () => ({
  type: types.FETCH_REPORTS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/publisher/getReports`,
    method: 'GET'
  }
});

export { getRatings, getQuality, getReports };
